<div
  class="spinner"
  *ngIf="isVisible"
  role="status"
  aria-live="polite"
  aria-busy="true"
>
  <span class="cdk-visually-hidden">{{
    (message$ | async) || "Cargando"
  }}</span>
  <div class="loader" aria-hidden="true"></div>
  <p
    class="spinner__message"
    *ngIf="message$ | async as message"
    aria-hidden="true"
  >
    {{ message }}
  </p>
</div>
